import { apiRequest } from './http';

// 광고 네트워크 Management API 조회.
// 네트워크가 늘면 이 union과 backend의 _PROVIDER_FACTORIES를 함께 늘리면 된다.
export type NetworkCode = 'dt' | 'unity' | 'vungle' | 'tapjoy';

export interface NetworkAppMatch {
  code: string;              // 플랫폼 code ('aos' / 'ios' ...)
  store_id: string;
  network_app_id: string;
  name: string | null;
  status: string | null;
}

export interface NetworkAppLookupResponse {
  network: string;
  label: string;
  // null이면 그 store_id로 네트워크에 등록된 앱이 없다는 뜻 (오류가 아님).
  match: NetworkAppMatch | null;
}

// POST /api/network-apps/{network}/lookup — 플랫폼 하나의 store_id로 네트워크 앱 ID 조회.
// 저장은 하지 않는다: 결과를 폼에 채운 뒤 기존 저장/요청 흐름을 그대로 탄다.
export function lookupNetworkApp(
  network: NetworkCode,
  code: string,
  storeId: string,
): Promise<NetworkAppLookupResponse> {
  return apiRequest<NetworkAppLookupResponse>(`/network-apps/${network}/lookup`, {
    method: 'POST',
    body: { code, store_id: storeId },
  });
}
